var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{staticClass:"custom-draw",attrs:{"title":_vm.title,"visible":_vm.isVisible,"size":_vm.width,"append-to-body":_vm.appendToBody,"wrapperClosable":_vm.wrapperClosable},on:{"close":_vm.beforeClose,"closed":_vm.closeDialog}},[_vm._t("title",null,{"slot":"title"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }